import gql from "graphql-tag";
import client from "../data/client"

const service = {
    getDataset(id, token) {
        return client.api.query({
            query: gql `
                {
                    getDataset(id:"${id}", token:"${token}") {
                        id
                        title
                        description
                        status
                        collection {
                            id
                            title
                            description
                            status
                        }
                        source
                        update_frequency
                        owning_department
                        owning_person
                        contact
                        reviewer_email
                        s3_location
                        s3_details {
                            LastModified
                            ContentLength
                        }
                        data_source
                        featured
                        isPublic
                        img_url
                        publish_date
                        published_by
                        last_update
                        last_update_by
                        tags
                        external_url
                        dataviews {
                            id
                            title
                            description
                            query_url
                            query_explanation
                            default_view
                            last_update
                            last_update_by
                        }
                        datacolumns {
                            column_name
                            column_description
                        }
                        related_dataset {
                            id
                            title
                            description
                            collection {
                                id
                                title
                                description
                            }
                            data_source
                            last_update
                        }
                        number_of_records
                        visibility
                    }
                }
            `
        })
        .then(response => response.data.getDataset)
    },
    searchDatasets(body={}) {
        let escaped = JSON.stringify(JSON.stringify(body))
        return client.api.query({
            query: gql `
                {
                    searchDatasets(body:${escaped}) {
                        id
                        title
                        description
                        featured
                        last_update
                        data_source
                        external_url
                        s3_location
                        s3_details {
                            LastModified
                            ContentLength
                        }
                        publish_date
                        owning_department
                        external_url
                        collection {
                            id
                            title
                            description
                            status
                        }
                        datacolumns {
                            column_name
                            column_description
                        }
                        number_of_records
                        visibility
                    }
                }
            `
        })
        .then(response => response.data.searchDatasets)
    },
    listFeatured() {
        let escaped = JSON.stringify(JSON.stringify({"query": { "match": { "featured": true } } }))
        return client.api.query({
            query: gql `
                {
                    searchDatasets(body:${escaped}) {
                        id
                        title
                        description
                        featured
                        img_url
                    }
                }
            `
        })
        .then(response => response.data.searchDatasets)
    },
    countDatasets(body={}) {
        let escaped = JSON.stringify(JSON.stringify(body))
        return client.api.query({
            query: gql `
                {
                    countDatasets(body:${escaped})
                }
            `
        })
        .then(response => response.data.countDatasets)
    },
    getCollection(id) {
        return client.api.query({
            query: gql `
                {
                    getCollection(id:"${id}") {
                        title
                        description
                        status
                        datasets {
                            id
                            title
                            description
                            last_update
                            s3_details {
                                LastModified
                                ContentLength
                            }
                            number_of_records
                        }
                    }
                }
            `
        })
        .then(response => response.data.getCollection)
    },
    getDataview(datasetId, dataviewId) {
        return client.api.query({
            query: gql `
                {
                    getDataview(datasetId:"${datasetId}", dataviewId:"${dataviewId}") {
                        id
                        title
                        description
                        query_url
                        query_explanation
                        default_view
                        last_update
                        last_update_by
                    }
                }
            `
        })
    },
    getAlert(id) {
        return client.api.query({
            query: gql`
                {
                    getAlert(id:"${id}") {
                        id
                        alert_text
                        priority
                        expire
                        status
                        created_by
                        creation_date
                    }
                }
            `
        })
    },
    listAlerts() {
        return client.api.query({
            query: gql`
                {
                    listAlerts {
                        id
                        alert_text
                        priority
                        expire
                        status
                        created_by
                        creation_date
                    }
                }
            `
        })
    }
}

export default service;
